// Inline sensitive asks: which field's inline control is live right now, if
// any. One hook for the readers that must agree — the control itself
// (`InlineFieldAsk`), the composer's lock (`MessageSender`) and the Home input
// (`SplashActions`) — so the composer is locked exactly when a control is on
// screen.
//
// The liveness rule itself is the pure `liveInlineField` selector; this only
// feeds it the ids the chat history carries.

import { useContext, useMemo } from 'react';
import { AppContext } from '../App/AppContext';
import { useConversationalForms } from './FormsContext';
import { liveInlineField } from './formsSelectors';
import { CfField } from './types';

export const useLiveInlineField = (): CfField | undefined => {
    const { active, registry, state } = useConversationalForms();
    const { state: appState } = useContext(AppContext);
    const messages = appState.messages;
    return useMemo(
        () =>
            active
                ? liveInlineField(
                      state,
                      registry,
                      (messages ?? []).map((m) => m.inlineAskFieldId)
                  )
                : undefined,
        [active, state, registry, messages]
    );
};
